import { HiExternalLink } from "react-icons/hi";
import Container from "./../Components/Container";
import { projects } from "../Inc/data";

export default function Projects() {
  return (
    <section id="projects" className="min-h-[calc(100vh-70px)] snap-start">
      <Container transparent outterPadding="" innerPadding="pt-6">
        <div className="flex flex-col justify-center items-center">
          <div className="text-sky-800 font-extrabold">Project</div>
          <div className="text-2xl font-semibold">My Recent Works</div>
          <div className="h-1 bg-sky-800 w-36 my-2"></div>
        </div>

        <div className="grid lg:grid-cols-3 gap-3 mt-4">
          {projects.map((_, i) => (
            <div
              key={i}
              className={
                "max-w-full group transition-all duration-300 rounded-lg shadow flex flex-col " +
                " bg-white hover:bg-sky-800 hover:text-white border border-gray-200 " +
                "hover:scale-[1.02] " +
                (i % 3 === 0
                  ? "hover:rotate-1"
                  : i % 3 === 2
                  ? "hover:-rotate-1"
                  : "")
              }
            >
              <a href={_.link} target="_blank" rel="noreferrer">
                <img
                  className="rounded-t-lg h-48 w-full object-cover"
                  src={_.image}
                  alt=""
                />
              </a>
              <div className="flex-1 p-5 flex flex-col">
                <a
                  href={_.link}
                  target="_blank"
                  rel="noreferrer"
                  className="mb-2 text-2xl font-bold tracking-tight text-gray-900 group-hover:text-white"
                >
                  {_.title}
                </a>
                <p className="mb-3 font-normal text-gray-700 group-hover:text-white">
                  {_.description}
                </p>
                <div className="flex justify-end mt-auto">
                  <a
                    href={_.link}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex gap-2 items-center px-3 py-2 text-sm font-medium text-center text-white bg-sky-800 group-hover:bg-white group-hover:text-sky-800 rounded-lg hover:bg-sky-900 focus:ring-4 focus:outline-none focus:ring-sky-300"
                  >
                    <span>View</span>
                    <HiExternalLink />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
